<template>
  <div class="d-flex flex-column flex-root">
    <div class="rbs-loader" v-if="false">
      <img src="/static/img/logo/Logo-Default.svg" />
    </div>
    <tas-header-mobile-component />
    <div class="d-flex flex-column flex-root">
      <div class="d-flex flex-row flex-column-fluid page">
        <!--begin::Aside-->
        <tas-aside-left-component />
        <div
          v-if="$store.state.sideNavMobile"
          @click="hideMobileMenu()"
          class="aside-overlay"
          style="z-index: 1025 !important"
        ></div>
        <!--end::Aside-->
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
          <!--begin::Content-->
          <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
            <!-- <tas-subheader-component :title="$route.meta.title"></tas-subheader-component> -->
            <div class="d-flex flex-column-fluid pt-md-5">
              <router-view />
            </div>
          </div>
          <!--end::Content-->
          <!--begin::Footer-->
          <tas-footer-component />
          <!--end::Footer-->
        </div>
      </div>
    </div>
    <!--begin::Scrolltop-->
    <div id="kt_scrolltop" class="scrolltop">
      <span class="svg-icon">
        <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Up-2.svg-->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          version="1.1"
        >
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon points="0 0 24 0 24 24 0 24" />
            <rect
              fill="#000000"
              opacity="0.3"
              x="11"
              y="10"
              width="2"
              height="10"
              rx="1"
            />
            <path
              d="M6.70710678,12.7071068 C6.31658249,13.0976311 5.68341751,13.0976311 5.29289322,12.7071068 C4.90236893,12.3165825 4.90236893,11.6834175 5.29289322,11.2928932 L11.2928932,5.29289322 C11.6714722,4.91431428 12.2810586,4.90106866 12.6757246,5.26284586 L18.6757246,10.7628459 C19.0828436,11.1360383 19.1103465,11.7686056 18.7371541,12.1757246 C18.3639617,12.5828436 17.7313944,12.6103465 17.3242754,12.2371541 L12.0300757,7.38413782 L6.70710678,12.7071068 Z"
              fill="#000000"
              fill-rule="nonzero"
            />
          </g>
        </svg>
        <!--end::Svg Icon-->
      </span>
    </div>
    <template v-if="!tourGuide">
      <tour-guide-component @done="onTourDone" />
    </template>

    <!-- <tas-aside-right-component /> -->
  </div>
</template>

<style>
@keyframes blink {
  0% {
    opacity: 0.3;
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}
.rbs-loader {
  width: 100vw;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 100;
}

.rbs-loader img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-animation: blink 1s linear infinite;
  -moz-animation: blink 1s linear infinite;
  animation: blink 1s linear infinite;
  width: 75px;
  height: auto;
}
</style>

<script>
export default {
  name: "admin-dashboard-layout",
  components: {
    TasHeaderMobileComponent: () => import("@/components/tas-header-mobile.vue"),
    TasAsideLeftComponent: () => import("@/components/tas-aside-left.vue"),
    // TasAsideRightComponent: () => import('@/components/tas-aside-right.vue'),
    TasFooterComponent: () => import("@/components/tas-footer.vue"),
    TasSubheaderComponent: () => import("@/components/tas-subheader.vue"),
    TourGuideComponent: () => import("@/components/tour-guide.vue"),
  },
  data() {
    return {
      tourGuide: this.$store.state.allow_guides === "Y",
      isLoading: false,
      // tourGuide: false
    };
  },
  methods: {
    hideMobileMenu() {
      this.$store.commit("set", ["sideNavMobile", false]);
      this.$_sys.togleClass("kt_aside", "aside-on", false);
    },
    onTourDone() {
      this.$store.commit("set", ["allow_guides", "N", true]);
      this.tourGuide = true;
    },
  },

  computed: {
    allowGuides() {
      return this.$store.state.allow_guides;
    },
    loading() {
      return this.$store.state.loading;
    },
  },

  watch: {
    allowGuides() {
      this.tourGuide = this.$store.state.allow_guides === "Y";
    },
    loading() {
      this.isLoading = this.loading;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/tas-admin.vue